<ng-container *ngIf="{
    displayHeadIndustries: displayHeadIndustries$ | async,
    headIndustriesExpandedMap: headIndustriesExpandedMap$ | async,
    industriesSelectedMap: industriesSelectedMap$ | async,
    allIndustriesMap: allIndustriesMap$ | async,
    selectedIndustriesDisplayTags: selectedIndustriesDisplayTags$ | async,
    maxIndustriesReached: maxIndustriesReached$ | async,
    systemConfigs: systemConfigs$ | async
} as data">
    <div>
        <h2 class="industry-header-label" mat-dialog-title>{{(industryData.label ? industryData.label : 'label.FillInAnnouncementIndustry') | translate}}</h2>
    </div>

    <mat-dialog-content>
    <div class="top-container">
        <div class="categories-selection">
            <div class="query-container">
                <input class="query-container__input" (input)="onSearch($event)" type="text"
                    placeholder="({{ 'label.Search' | translate }})" />
            </div>
            <div class="categories-container">
                <div class="head-category" *ngFor="let head of data.displayHeadIndustries">
                    <div style="display: flex; cursor: pointer;" (click)="onToggleExpandHeadIndustry(head)">
                        <div style="padding-bottom: 0.2rem;">
                            <svg-icon src="/assets/icons/chevron-down.svg"
                                [svgStyle]="{ 'width.rem':'0.81', 'stroke': 'black', 'transform': data.headIndustriesExpandedMap[head.id] ? 'none' : 'rotate(180deg)' }">
                            </svg-icon>
                        </div>
                        <div style="padding-left: 0.7rem;">{{head.name}}</div>
                    </div>

                    <div style="padding-top: 1.5rem; padding-left: 1.7rem;"
                        [ngStyle]="{'display': data.headIndustriesExpandedMap[head.id]  ? 'block' : 'none'}">
                        <div *ngFor="let industry of head.childIndustryIds">
                            <mat-checkbox [disabled]="data.maxIndustriesReached && !data.industriesSelectedMap[industry]" (change)="onToggleIndustry(industry, $event)"
                                [ngModel]="data.industriesSelectedMap[industry]"
                                [ngModelOptions]="{standalone: true}">{{data.allIndustriesMap[industry].name}}
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="industry-chips">
            <div class="chips-container">
                <div class="industry-tag" *ngFor="let industry of data.selectedIndustriesDisplayTags">
                    <div (click)="onRemoveIndustry(industry.id)" class="industry-tag__item">
                        {{ industry?.name }}
                        <svg-icon src="/assets/icons/remove.svg" class="remove-icon"></svg-icon>
                    </div>
                </div>
            </div>
            <div class="warning-message">
                <div>{{ 'message.PositionMaxIndustryWarning' | translate: {max: data.systemConfigs.common.industryPickerMaxSelect} }}</div>
            </div>
        </div>
    </div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <div class="buttons">
            <app-button [ngClass]="{'disabled': false}"
                (click)="onSave(data.selectedIndustriesDisplayTags)" [text]="'label.Save' | translate"
                [type]="buttonType.coloured" [typeAttribute]="buttonAttributeType.submit" class="button-save"></app-button>
            <app-button [text]="'label.Cancel' | translate" [type]="buttonType.uncoloured" [typeAttribute]="buttonAttributeType.button" (click)="onCancel()">
            </app-button>
        </div>
    </mat-dialog-actions>
</ng-container>